import script from "./OuterLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./OuterLayout.vue?vue&type=script&setup=true&lang=js"

import "./OuterLayout.vue?vue&type=style&index=0&id=1053f5f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1053f5f0"]])

export default __exports__